import {setLanguageCode} from 'src/i18n';

const prefix = 'LAYOUT';

const layoutActions = {
  MENU_TOGGLE: `${prefix}_MENU_TOGGLE`,
  MENU_HIDE: `${prefix}_MENU_HIDE`,
  MENU_SHOW: `${prefix}_MENU_SHOW`,
  DRAWER_VISIBLE: `${prefix}_DRAWER_VISIBLE`,

  doChangeLanguage: (language) => {
    const success = setLanguageCode(language);

    /**
     * I18n is outside Redux store,
     * no we need this hack to load it properly
     */
    if (success) {
      (window as any).location.reload();
    }
  },

  doToggleMenu: () => {
    return {
      type: layoutActions.MENU_TOGGLE,
    };
  },

  doShowMenu: () => {
    return {
      type: layoutActions.MENU_SHOW,
    };
  },

  doHideMenu: () => {
    return {
      type: layoutActions.MENU_HIDE,
    };
  },

  doVisibleDrawer: (payload) => {
    return {
      type: layoutActions.DRAWER_VISIBLE,
      payload,
    };
  },
};

export default layoutActions;
